// extracted by mini-css-extract-plugin
module.exports = {"sectionAdmin":"SectionAdmin_sectionAdmin__1QXYj","sectionHeading":"SectionAdmin_sectionHeading__2G-Q8","sectionContent":"SectionAdmin_sectionContent__rtqOJ"};